module.exports = __webpack_public_path__ + "img/sphone_attendpage_zoom.0e8eb175.png";